export default __webpack_public_path__ + "static/Temoignage-1a6fa773b3e05c94165742adc465c12c.png";